<template>
    <div>
        <router-view name="monitoring"></router-view>
    </div>
</template>

<script>
  export default {
    name: 'monitoring_main',
    mounted () {
    }
  }
</script>

<style>
</style>
